import { useQuery } from '@tanstack/react-query';

import { IUniversityBall } from '../models';
import { getUniversityBall } from '../queries';
import { universitiesConst } from '..';

export const useUniversityBall = ({
  univerId,
  year,
  language,
  study
}: {
  univerId?: string | string[];
  year?: number;
  language?: string;
  study?: string;
}) => {
  const { data: universityBall, ...args } = useQuery<IUniversityBall[]>({
    queryKey: [universitiesConst.queryKeys.UNIVERSITIES_BALL, { univerId, year, language, study }],
    queryFn: getUniversityBall({ univerId, year, language, study }),
    enabled: !!univerId && !!year
  });

  return { universityBall, ...args };
};
